import { render, staticRenderFns } from "./homeTuandui.vue?vue&type=template&id=6c56e220&"
import script from "./homeTuandui.vue?vue&type=script&lang=js&"
export * from "./homeTuandui.vue?vue&type=script&lang=js&"
import style0 from "./homeTuandui.vue?vue&type=style&index=0&id=6c56e220&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports